import { create } from "zustand";
import { produce } from "immer";

const defaultData = {
  plans: false,
};

export const usePlans = create((set) => ({
  data: defaultData,
  actions: {
    setPlans: (plans) =>
      set((state) =>
        produce(state, (draft) => {
          draft.data.plans = plans;
        })
      ),

    setPlanFactor: (planId, factor) =>
      set((state) =>
        produce(state, (draft) => {
          const index = state.data.plans.findIndex(
            (plan) => plan.id === planId
          );
          if (!~index) return;
          draft.data.plans[index].factor = factor;
        })
      ),
    fixPlansFactor: () =>
      set((state) =>
        produce(state, (draft) => {
          draft.data.plans = state.data.plans.map((plan) => ({
            ...plan,
            oldFactor: plan.factor,
            sizes: plan.sizes.map((s) => ({ ...s, oldValue: s.value })),
          }));
        })
      ),

    undoPlansFactor: () =>
      set((state) =>
        produce(state, (draft) => {
          draft.data.plans = state.data.plans.map((plan) => ({
            ...plan,
            factor: plan.oldFactor,
            sizes: plan.sizes.map((s) => ({ ...s, value: s.oldValue })),
          }));
        })
      ),

    setSizeValue: (planId, sizeId, value) =>
      set((state) =>
        produce(state, (draft) => {
          const planIndex = state.data.plans.findIndex(
            (plan) => plan.id === planId
          );
          if (!~planIndex) return;
          
          const sizeIndex = state.data.plans[planIndex].sizes.findIndex(
            (size) => size.id === sizeId
          );
          if (!~sizeIndex) return;
          
          draft.data.plans[planIndex].sizes[sizeIndex].value = value;
        })
      ),

    clear: () =>
      set((state) =>
        produce(state, (draft) => {
          draft.data = defaultData;
        })
      ),
  },
}));
